import DOMPurify from 'dompurify';
import React from 'react';

const parseHTMLToJSX = (htmlString) => {
  const sanitizedHTML = DOMPurify.sanitize(htmlString);
  const tempElement = document.createElement('div');
  tempElement.innerHTML = sanitizedHTML;

  return Array.from(tempElement.childNodes).map((node, index) => {
    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent;
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      const element = node;
      return React.createElement(
        element.tagName.toLowerCase(),
        { key: index },
        parseHTMLToJSX(element.innerHTML) // Recursively parse nested HTML
      );
    }
    return null;
  });
};

export default parseHTMLToJSX;
